import React, { useState, useEffect, useContext, useRef } from "react";
import { usePublicChat } from "../hooks/usePublicChat";
import { UserContext } from "../../../contexts/UserContext";
import ChatSlider from "./ChatSlider";
import { ChatContext } from "../../../contexts/ChatContext";

export default function PublicChatToggleView({
  event,
  page,
  showPublicChat,
  corporateOrganization,
  expandedView,
}) {


  
  const { me } = useContext(UserContext);

  const [urlParams, setUrlParams] = useState(null);
  const [publicChatListArr, setPublicChatListArr] = useState(null);

  const { publicChatList } = usePublicChat({
    me,
    urlParams,
  });

 
  const createChatArray = (initMount = false) => {
    const allChatList = [];

    if (publicChatList !== null) {
      allChatList.push(...Object.entries(publicChatList));
    }

    return allChatList;
  };

  useEffect(() => {
    if (event && page && showPublicChat) {
      setUrlParams({
        eventSlug: event,
        pageSlug: page,
        organizationSlug: corporateOrganization?.slug ?? "",
      });
    }
  }, [event, page, corporateOrganization, showPublicChat]);

  useEffect(() => {
    setPublicChatListArr(createChatArray());
  }, [publicChatList, me, urlParams, event, page]);

  return (
    <>
      {me && urlParams && (
        <>
          {showPublicChat &&
            publicChatListArr &&
            publicChatListArr.map((item, index) => {
              item.primaryChatName = "Live Chat";
              item.restInfo = "";
              return (
                <>
                  <ChatSlider
                    key={index}
                    chatItem={item}
                    animationDirection={"slide-y"}
                  />
                </>
              );
            })}
        </>
      )}
    </>
  );
}
